import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'MP',
  quote: 'Organicé todo el mes en una tarde. Nunca más llego a la pileta sin saber qué dar.',
  name: 'Martín P., Buenos Aires',
  role: 'Profesor de Natación en Club Deportivo',
  color: 'bg-blue-100 text-blue-700'
}, {
  initials: 'CG',
  quote: 'Mis alumnos adultos iniciales mejoraron su flotación desde la primera semana con el Tomo 5.',
  name: 'Claudia G., Córdoba',
  role: 'Profesora de Natación en Academia Privada',
  color: 'bg-purple-100 text-purple-700'
}, {
  initials: 'FR',
  quote: 'Antes tardaba 1 hora armando una clase. Ahora son 5 minutos.',
  name: 'Federico R., Rosario',
  role: 'Profesor de Natación Independiente',
  color: 'bg-green-100 text-green-700'
}];
export function QuickTestimonials() {
  return <section className="py-12 bg-white" data-id="element-289">
      <div className="max-w-6xl mx-auto px-4" data-id="element-290">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-291">
          {testimonials.map((t, i) => <div key={i} className="bg-gray-50 rounded-2xl p-6 border border-gray-100 shadow-sm transition-transform hover:-translate-y-1" data-id="element-292">
              <div className="flex items-center gap-4 mb-4" data-id="element-293">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg ${t.color}`} data-id="element-294">
                  {t.initials}
                </div>
                <div data-id="element-295">
                  <div className="font-bold text-gray-900 text-sm" data-id="element-296">
                    {t.name}
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-297">{t.role}</div>
                </div>
              </div>
              <div className="flex gap-0.5 mb-3" data-id="element-298">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-299" />)}
              </div>
              <p className="text-gray-700 italic text-sm leading-relaxed" data-id="element-300">
                "{t.quote}"
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}